import React, {
  createContext, useCallback, useContext, useMemo, useState,
} from 'react';
import PropTypes from 'prop-types';

export const StoresSearchContext = createContext({
  title: null,
  page: 1,
});

export const useStoresSearchPage = () => useContext(StoresSearchContext);
const Provider = ({ children }) => {
  const [title, setTitle] = useState('Loja');
  const [filter, setFilter] = useState(null);
  const [filterString, setFilterString] = useState(null);
  const handleTitle = useCallback((newTitle) => {
    setTitle(newTitle);
  }, [title]);

  const handleFilterString = useCallback((fString) => {
    setFilterString(fString);
  }, [filterString]);

  const handleFilter = useCallback((f, fString) => {
    setFilter(f);
    if (fString !== null && fString !== undefined) handleFilterString(fString);
  }, [filter]);

  const value = useMemo(() => {
    return {
      title,
      filter,
      filterString,
      setTitle: handleTitle,
      setFilter: handleFilter,
      setFilterString: handleFilterString,
    };
  }, [title, filter, filterString, handleTitle, handleFilter, handleFilterString]);

  return (
    <StoresSearchContext.Provider value={value}>
      { children }
    </StoresSearchContext.Provider>
  );
};

Provider.propTypes = {
  children: PropTypes.node
};

export default Provider;
